const EXISTING_SHIP = 'existing-ship';
const NEW_BUILD = 'new-build';

const constants = {
  EXISTING_SHIP,
  NEW_BUILD,
};

const tooltipsConstants = {
  HELP_TEXT_ANNUAL_LEAKAGE_RATE: 'HelpTextAnnualLeakageRate',
  HELP_TEXT_HIGH_GWP_REFRIGERANT: 'HelpTextHighGwpRefrigerant',
  HELP_TEXT_LOW_GWP_REFRIGERANT: 'HelpTextLowGwpRefrigerant',
  // HELP_TEXT_REFRIGERANT_LOSS: 'HelpTextRefrigerantLoss',
  HELP_TEXT_TOTAL_QUANTITY_NEW_BUILD: 'NewBuildHelpTextTotalQuantity',
  HELP_TEXT_TOTAL_QUANTITY_EXISTING_SHIP: 'ExistingHelpTextTotalQuantity',
};

const equivalentConstants = {
  NumberOfCars: {label:"Number of gasoline powered passenger cars taken off the road", iconUrl: "/Static/prod/images/car.svg"},
  NumberOfHomes: {label: "Number of homes electricity use", iconUrl: "/Static/prod/images/house.svg"},
  NumberOfSmartphones: {label: "Number of smartphones charged", iconUrl: "/Static/prod/images/phone.svg"},
  NumberOfTreesPlanted: {label: "Number of tree seedings needed to convert CO2 to oxygen for 10 years", iconUrl: "/Static/prod/images/tree.svg"}
}

const LEAKAGE_MIN_RATE = 20;
const LEAKAGE_MAX_RATE = 40;

function isNumberKey(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;

    // arrows
    if (charCode >= 37 && charCode <= 40) {
        return true;
    }

    // delete, backspace, tab, period
    if (
        charCode === 46 ||
        charCode === 8 ||
        charCode === 9 ||
        charCode === 190 ||
        charCode === 110 // numpad decimal
    ) {
        return true;
    }

    // top-row numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
        return true;
    }

    // numpad numbers (0-9)
    if (charCode >= 96 && charCode <= 105) {
        return true;
    }

    return false;
}

const createTooltip = (content) => {
  const tooltipEl = document.createElement('div');
  tooltipEl.classList.add('refrigerant-calculator__tooltip');

  const tooltipBox = document.createElement('div');
  tooltipBox.classList.add('refrigerant-calculator__tooltip-box');

  const tooltipContent = document.createElement('div');
  tooltipContent.style.width = '220px';
  tooltipContent.style.paddingRight = '6px';
  tooltipContent.innerHTML = content;

  const closeBtn = document.createElement('button');
  closeBtn.classList.add('refrigerant-calculator__tooltip-close-btn');

  tooltipBox.append(tooltipContent, closeBtn);

  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    tooltipBox.style.visibility = 'hidden';
  });
  tooltipEl.addEventListener('click', function () {
    const tooltips = document.querySelectorAll(
      '.refrigerant-calculator__tooltip-box'
    );
    tooltips.forEach((item) => {
      item.style.visibility = 'hidden';
    });

    tooltipBox.style.visibility = 'visible';
  });

  tooltipEl.append(tooltipBox);

  return tooltipEl;
};

const getTooltips = () => {
  const tooltipsContainer = document.querySelector(
    '.refrigerant-calculator__tooltips'
  );
  const tooltipsList = Array.from(tooltipsContainer.children);

  const tooltipsObj = {};

  tooltipsList.forEach((item) => {
    const { id, content } = item.dataset;
    tooltipsObj[id] = content;
  });

  return tooltipsObj;
};

const getLeakagePreview = () => {
  const leakagePercentageInput = document.getElementById(
    `${NEW_BUILD}-leakage-rate`
  );
  const quantityInput = document.getElementById(`${NEW_BUILD}-quantity`);

  const quantity = Number(quantityInput.value);
  const percentage = Number(leakagePercentageInput.value);

  const result = Number((quantity * (percentage / 100)).toFixed(2));

  return result;
};

const createStats = ({ items, type }) => {
  const chosenItem = items.find((item) => item.IsChosen === true);
  const { EmissionReduction, Name } = chosenItem;

  let emissionReductionString = EmissionReduction.ValueInKg.toLocaleString(
    'en-US'
  );
  emissionReductionString = `${emissionReductionString} <span>kg&nbsp;CO₂e</span>`;

  const percentageString = EmissionReduction.Percentage.toLocaleString('en-US');

  const wrapperEl = document.createElement('div');
  wrapperEl.classList.add('refrigerant-stats');

  const headingEl = document.createElement('p');
  headingEl.classList.add('refrigerant-stats__heading');
  headingEl.innerHTML =
    type === EXISTING_SHIP
      ? `Adopting <b>${Name}</b> can help you reduce yearly emission by:`
      : 'Adopting the low GWP refrigerant type you have avoided yearly emission by:';

  const amountHeadingEl = document.createElement('h2');
  amountHeadingEl.classList.add('refrigerant-stats__amount-heading');
  amountHeadingEl.innerHTML = emissionReductionString;

  const reductionHeadingEl = document.createElement('h3');
  reductionHeadingEl.classList.add('refrigerant-stats__reduction-heading');
  reductionHeadingEl.innerHTML = `<strong>${percentageString}% CO₂e reduction</strong>`;

  const equivalentListEl = createEquivalentList(chosenItem);


  const otherRefrigerantsHeadingEl = document.createElement('p');
  otherRefrigerantsHeadingEl.classList.add('refrigerant-stats__other-heading');
  otherRefrigerantsHeadingEl.textContent =
    type === EXISTING_SHIP
      ? 'Other Retrofit Refrigerants:'
      : 'Other Low GWP Refrigerants:';

  const coEmissionTextEl = document.createElement('p');
  coEmissionTextEl.classList.add('refrigerant-stats__co-emission');
  coEmissionTextEl.innerHTML = `CO₂e emission`;

  const graphEl = createGraph(items, type);

  const printButton = document.createElement('div');
  printButton.classList.add('refrigerant-stats__print-btn');
  const printLink = document.createElement('a');
  printLink.setAttribute('href', 'javascript:window.print()');
  printLink.classList.add(
    'products-link--inverted',
    'products-icon',
    'products-icon--print'
  );
  printLink.innerHTML = 'Print';
  printButton.append(printLink);

  wrapperEl.append(
    headingEl,
    reductionHeadingEl,
    amountHeadingEl,
    equivalentListEl,
    otherRefrigerantsHeadingEl,
    coEmissionTextEl,
    graphEl,
    printButton
  );

  return wrapperEl;
};

const createEquivalentItem = ({value, label, iconUrl}) => {
  const itemEl = document.createElement('li');
  itemEl.classList.add("refrigerant-stats__equivalent-item");

  let itemValueString = value.toLocaleString('en-US');

  const itemValueIconEl = document.createElement('span');
  itemValueIconEl.classList.add("refrigerant-stats__equivalent-item-icon");
  const iconEl = document.createElement('img');
  iconEl.setAttribute('src', iconUrl);
  itemValueIconEl.append(iconEl);
  itemEl.append(itemValueIconEl);

  const textsEl = document.createElement('span');
  const itemValueEl = document.createElement('h4');
  itemValueEl.textContent = itemValueString;
  textsEl.append(itemValueEl);
  const itemLabelEl = document.createElement('p');
  itemLabelEl.textContent = label;
  textsEl.append(itemLabelEl);
  itemEl.append(textsEl);

  return itemEl;
}

const createEquivalentList = (chosenItem) => {
  const wrapperEl = document.createElement('div');
  wrapperEl.classList.add('refrigerant-stats__equivalent')

  const equivalentHeadingEl = document.createElement('p');
  equivalentHeadingEl.classList.add('refrigerant-stats__equivalent-heading')
  equivalentHeadingEl.textContent = 'The amount of CO₂ is equivalent to:';
  wrapperEl.append(equivalentHeadingEl);

  const equivalentItemsEl = document.createElement('ul');
  equivalentItemsEl.classList.add("refrigerant-stats__equivalent-items")

  for (const [key, value] of Object.entries(chosenItem.EmissionReduction)) {
    if (Object.keys(equivalentConstants).includes(key)) {
      const equivalentItem = createEquivalentItem({
        value: value,
        label: equivalentConstants[key].label,
        iconUrl: equivalentConstants[key].iconUrl
      });
      equivalentItemsEl.append(equivalentItem);
    }
  }
  wrapperEl.append(equivalentItemsEl);

  const equivalentDescriptionEl = document.createElement('p');
  equivalentDescriptionEl.classList.add('refrigerant-stats__equivalent-description')
  equivalentDescriptionEl.textContent = `Estimated values are taking reference from `;
  const epaLink = document.createElement('a');
  epaLink.setAttribute('href', 'https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references');
  epaLink.setAttribute('target', "_blank");
  epaLink.setAttribute('rel', "noopener noreferrer");
  epaLink.innerHTML = 'EPA&nbsp;greenhouse gas equivalencies calculator';
  equivalentDescriptionEl.append(epaLink)
  wrapperEl.append(equivalentDescriptionEl);

  return wrapperEl;
}

const createGraph = (items, type) => {
  const wrapperEl = document.createElement('ul');
  wrapperEl.classList.add('refrigerant-stats__graph');

  items.forEach((item) => {
    const { Name, IsCurrent, IsChosen, EmissionReduction } = item;

    const listItem = createGraphItem({
      name: Name,
      isCurrent: IsCurrent,
      isChosen: IsChosen,
      percentage: EmissionReduction.Percentage,
      type: type,
    });

    wrapperEl.append(listItem);
  });

  return wrapperEl;
};

const createGraphItem = ({ isCurrent, isChosen, percentage, name, type }) => {
  const percentageString = percentage.toLocaleString('en-US');

  const wrapper = document.createElement('li');
  wrapper.classList.add('refrigerant-stats__item');

  const nameEl = document.createElement('p');
  nameEl.classList.add('refrigerant-stats__item-name');
  if (isCurrent) {
    nameEl.innerHTML =
      type === NEW_BUILD ? 'High GWP Refrigerant' : 'Your current refrigerant';
  } else {
    nameEl.innerHTML = name;
  }

  if (isCurrent || isChosen) {
    nameEl.classList.add('highlighted');
  }

  const progressWrapper = document.createElement('div');
  progressWrapper.classList.add('refrigerant-stats__progress-box');

  if (isCurrent) {
    progressWrapper.classList.add('current');
  } else if (isChosen) {
    progressWrapper.classList.add('chosen');
  }

  const progressBar = document.createElement('div');
  progressBar.classList.add('refrigerant-stats__progress-bar');
  progressBar.style.width = `${Math.round(percentage)}%`;

  const percentageText = document.createElement('p');
  percentageText.classList.add('refrigerant-stats__progress-text');
  percentageText.innerHTML = isCurrent ? '' : `${percentageString}% reduction`;
  if (isCurrent) percentageText.style.display = 'none';

  progressWrapper.append(percentageText, progressBar);

  wrapper.append(nameEl, progressWrapper);

  return wrapper;
};

const addOptionsToSelect = ({ items, selectEl }) => {
  items.forEach((el) => {
    const { name, id } = el;
    selectEl.insertAdjacentHTML(
      'beforeend',
      `<option data-id="${id}" data-name="${name}">${name}</option>`
    );
  });
};

const updateOptionsInSelect = ({ id, items, placeholder }) => {
  const firstEl = document.createElement('option');
  firstEl.innerHTML = placeholder;

  const selectEl = document.getElementById(id);
  selectEl.innerHTML = '';
  selectEl.append(firstEl);

  addOptionsToSelect({ items, selectEl });
  if (items.length === 1) {
    selectEl.selectedIndex = 1;
  }
};

const createSelectElement = ({ label, placeholder, items, id, onChange }) => {
  const selectEl = document.createElement('select');
  const labelEl = document.createElement('label');
  const firstEl = document.createElement('option');

  labelEl.setAttribute('for', id);
  labelEl.innerHTML = label;

  firstEl.innerHTML = placeholder;
  selectEl.setAttribute('id', id);

  placeholder && selectEl.append(firstEl);
  addOptionsToSelect({ items, selectEl });

  selectEl.addEventListener('change', () => {
    const index = selectEl.selectedIndex;
    onChange && onChange(index);
  });

  return { selectEl, labelEl };
};

const createInputFields = (type) => {
  const tooltipsList = getTooltips();
  const {
    HELP_TEXT_TOTAL_QUANTITY_EXISTING_SHIP,
    HELP_TEXT_TOTAL_QUANTITY_NEW_BUILD,
    HELP_TEXT_ANNUAL_LEAKAGE_RATE,
    // HELP_TEXT_REFRIGERANT_LOSS,
  } = tooltipsConstants;

  const wrapperEl = document.createElement('div');
  wrapperEl.classList.add('refrigerant-calculator__inputs-wrapper');

  const quantityWrapper = document.createElement('div');
  const quantityLabelEl = document.createElement('label');
  quantityLabelEl.innerHTML = 'Total Quantity';
  quantityLabelEl.setAttribute('for', `${type}-quantity`);

  const quantityInputEl = document.createElement('input');
  quantityInputEl.setAttribute('type', 'number');
  quantityInputEl.setAttribute('min', '0');
  quantityInputEl.setAttribute('value', `0`);
  quantityInputEl.setAttribute('id', `${type}-quantity`);

  if (type === NEW_BUILD) {
    const quantityTooltip = createTooltip(
      tooltipsList[HELP_TEXT_TOTAL_QUANTITY_NEW_BUILD]
    );
    quantityLabelEl.append(quantityTooltip);

    quantityInputEl.style.width = '180px';
  } else if (type === EXISTING_SHIP) {
    const quantityTooltip = createTooltip(
      tooltipsList[HELP_TEXT_TOTAL_QUANTITY_EXISTING_SHIP]
    );
    quantityLabelEl.append(quantityTooltip);
  }

  quantityInputEl.addEventListener('keydown', function (e) {
    if (!isNumberKey(e)) e.preventDefault();
  });

  const unitWrapper = document.createElement('div');
  const unitSelect = createSelectElement({
    label: 'Unit',
    items: [
      { name: 'kg', id: 'Kg' },
      { name: 'lbs', id: 'Lbs' },
    ],
    id: `${type}-unit`,
  });

  unitWrapper.append(unitSelect.labelEl, unitSelect.selectEl);
  quantityWrapper.append(quantityLabelEl, quantityInputEl);

  wrapperEl.append(quantityWrapper, unitWrapper);

  if (type === EXISTING_SHIP) {
    const periodWrapper = document.createElement('div');
    const items = [
      { name: 'Monthly', id: 12 },
      { name: 'Quarterly', id: 4 },
      { name: 'Annual', id: 1 },
    ];
    const { labelEl, selectEl } = createSelectElement({
      label: 'Period',
      items: items,
      id: `${type}-period`,
    });
    periodWrapper.append(labelEl, selectEl);

    wrapperEl.append(periodWrapper);
  } else if (type === NEW_BUILD) {
    const leakageWrapper = document.createElement('div');

    const leakageLabelEl = document.createElement('label');
    leakageLabelEl.innerHTML = 'Annual Leakage Rate';
    leakageLabelEl.setAttribute('for', `${type}-leakage-rate`);

    const leakageTooltip = createTooltip(
      tooltipsList[HELP_TEXT_ANNUAL_LEAKAGE_RATE]
    );
    leakageLabelEl.append(leakageTooltip);

    const leakageInputEl = document.createElement('input');
    leakageInputEl.setAttribute('type', 'number');
    leakageInputEl.setAttribute('min', '20');
    leakageInputEl.setAttribute('max', '40');
    leakageInputEl.setAttribute('value', `20`);
    leakageInputEl.setAttribute('id', `${type}-leakage-rate`);

    const leakageInnerWrapper = document.createElement('div');
    leakageInnerWrapper.classList.add(
      'refrigerant-calculator__leakage-wrapper'
    );

    const percentageEl = document.createElement('span');
    percentageEl.innerHTML = '%';

    const leakagePreviewEl = document.createElement('div');
    leakagePreviewEl.classList.add('refrigerant-calculator__leakage-preview');

    const lekagePreviewAmount = document.createElement('span');
    lekagePreviewAmount.textContent = '0';

    const unitTextEl = document.createElement('span');
    unitTextEl.innerHTML = 'kg';

    leakageInputEl.addEventListener('change', function (e) {
      if (e.target.value < LEAKAGE_MIN_RATE) {
        e.target.value = LEAKAGE_MIN_RATE;
      } else if (e.target.value > LEAKAGE_MAX_RATE) {
        e.target.value = LEAKAGE_MAX_RATE;
      }

      const amount = getLeakagePreview();
      lekagePreviewAmount.textContent = amount;
    });
    leakageInputEl.addEventListener('keydown', function (e) {
      if (!isNumberKey(e)) e.preventDefault();
    });

    quantityInputEl.addEventListener('change', function (e) {
      const amount = getLeakagePreview();
      lekagePreviewAmount.textContent = amount;
    });

    leakagePreviewEl.append(lekagePreviewAmount, unitTextEl);
    leakageInnerWrapper.append(leakageInputEl, percentageEl, leakagePreviewEl);
    leakageWrapper.append(leakageLabelEl, leakageInnerWrapper);

    wrapperEl.append(leakageWrapper);
  }

  return wrapperEl;
};

export {
  constants,
  tooltipsConstants,
  addOptionsToSelect,
  updateOptionsInSelect,
  createSelectElement,
  createInputFields,
  createStats,
  createTooltip,
  getTooltips,
};
